export default "__VITE_ASSET__CABwDECa__"